module.exports = __webpack_public_path__ + "media/images/vp/icon.arrow.right.gray-34e9a070122b078e802bf5d9eff343a3.svg";